module.exports = __webpack_public_path__ + "img/github.57553879.svg";